import {InfiniteData} from '@tanstack/react-query';
import {ReactNode, SyntheticEvent} from 'react';

export type ReactQueryGetKeyVariablesRequired<Variables> = {
  getKey: (variables: Variables) => (string | Variables)[];
};

export type ReactQueryGetKey<Variables> = {
  getKey: (variables?: Variables) => (string | Variables)[] | string[];
};

export type ReactQueryFetcherChildrenType<Query> =
  | ReactNode
  | ((data: Query) => ReactNode);

export interface ReactQueryInfiniteFetcherChildrenProps<Query> {
  children?: ReactQueryInfinityScrollFetcherChildrenType<Query>;
  enabled?: boolean;
  type: ReactQueryInfiniteType;
  onStartFetchNextPage?: (e: SyntheticEvent<HTMLDivElement>) => void;
  onStartFetchPrevPage?: (e: SyntheticEvent<HTMLDivElement>) => void;
  loadingWrapperClassName?: string;
}

export enum ReactQueryInfiniteType {
  InfinityScroll = 'InfinityScroll',
  ArrowDown = 'ArrowDown',
  ArrowUp = 'ArrowUp',
  ArrowBoth = 'ArrowBoth',
}

export type ReactQueryInfinityScrollFetcherChildrenType<Query> =
  | ReactNode
  | ((data: InfiniteData<Query>) => ReactNode);
